import { useRef } from 'react'
import Styles from './PostNowButton.module.scss'
import { useButton } from '@react-aria/button'
import { Send1 } from 'blaze-ui/icons'
import cx from 'classnames'

interface PostNowButtonProps {
  onPress?: () => void
  disabled?: boolean
}

const PostNowButton = ({ onPress, disabled = false }: PostNowButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton({ onPress, isDisabled: disabled }, ref)

  return (
    <button {...buttonProps} ref={ref} className={cx(Styles.root, disabled && Styles.disabled)}>
      <Send1 size={16} color="var(--dark-80)" />
    </button>
  )
}

export default PostNowButton
